import { useState, useCallback } from 'react'
import { TeacherSession } from 'common/utils/types/teacher-session'
import { persistentState } from 'common/utils/types/helpers'

export default function useTeacherSession() {
  const [session, setSession] = useState(() => {
    try {
      return persistentState.window.get('teacherSession') as TeacherSession
    } catch (err) {
      return null
    }
  })

  const refreshSession = () => {
    try {
      const freshSession = persistentState.window.get(
        'teacherSession',
        true
      ) as TeacherSession
      setSession(freshSession)
      return freshSession
    } catch (err) {
      return null
    }
  }

  return { session, refreshSession }
}

export const deleteTeacherSession = () => {
  window.sessionStorage.removeItem('teacherSession')
}
